import { Injectable } from '@angular/core';
import { ColDef } from 'ag-grid-community';
import { TranslateService } from '../../../api/translate.service';
import {
  fieldAddressLine1Col,
  fieldAddressLine2Col,
  fieldApprovedByCol,
  fieldBillingOfficeCol,
  fieldBuildingNameCol,
  fieldCarParkSpacesCol,
  fieldCompanyTypeCol,
  fieldConfidentialityStatusCol,
  fieldContractTypeCol,
  fieldCounterPartyCol,
  fieldCountryCol,
  fieldCreatedByCol,
  fieldCurrencyCol,
  fieldCustomerIdCol,
  fieldCustomerNameCol,
  fieldDateCol,
  fieldDealTypeAgileSpaceCol,
  fieldDedicatedClientNameCol,
  fieldDistrictCol,
  fieldExecutionDateCol,
  fieldFloorCol,
  fieldGridIdCol,
  fieldGstRateCol,
  fieldGwsEntityLocationCol,
  fieldIdCol,
  fieldInvoiceFeeBasisCol,
  fieldInvoiceHeaderCol,
  fieldInvoiceIdCol,
  fieldInvoiceTypeCol,
  fieldIsDataCenterDealCol,
  fieldIsGwsEntityCol,
  fieldLocalityCol,
  fieldMiqIdCol,
  fieldMoneyInTrustCol,
  fieldNoticeOfCancellationInMonthsCol,
  fieldOppNumberCol,
  fieldOpportunityCol,
  fieldOpportunityInstallmentCol,
  fieldOpportunitySourceCol,
  fieldOptionToRenewTheLeaseCol,
  fieldPaymentTermsCol,
  fieldPlaceOfSupplyCol,
  fieldPostcodeCol,
  fieldPrimaryEmployeeFunctionalUnitCol,
  fieldPrimaryEmployeeFunctionalUnitIdCol,
  fieldPrimaryEmployeeIdCol,
  fieldPrimaryEmployeeManagingOfficeCol,
  fieldPrimaryEmployeeManagingOfficeIdCol,
  fieldPrimaryEmployeeNameCol,
  fieldPropertyAreaCol,
  fieldPropertyManagedCol,
  fieldPropertySubtypeCol,
  fieldPropertyTypeCol,
  fieldPropertyTypeSpaceLabelCol,
  fieldPurchaseOrderCol,
  fieldRegionCol,
  fieldRepresentedPartyCol,
  fieldRepRolCol,
  fieldRetailBrandNameCol,
  fieldSgstUtgstPercentageCol,
  fieldSizeAreaMeasureCol,
  fieldSpaceConditionCol,
  fieldSubmittedByCol,
  fieldSuburbCol,
  fieldSuiteCol,
  fieldTeamCol,
  fieldTenantBankGuaranteeAmountCol,
  fieldTenantRetailCategoryCol,
  fieldTenantSecurityDepositAmountCol,
  fieldTotalInvoiceAmountCol,
  fieldTransactionTypeCol,
  fieldTransSubtypeCol,
  fieldMiqAvailabilityIdCol
} from '../../../utils/ag-grid/column-defs';

@Injectable({
  providedIn: 'root'
})
export class LeasePropertyCustomerReportService {

  constructor(private translateService: TranslateService) { }

  getHeaders(settings: { middle: any, left: any, right: any }) {
    return [
      {
        header: this.translateService.getTranslation('FINISHLINE_ID'),
        key: 'finishline_id',
        width: 20,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('INVOICE_ID'),
        key: 'invoice_id',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('TRANSACTION_TYPE'),
        key: 'transaction_type',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('INVOICE_DT'),
        key: 'invoiced_time',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('INVOICE_TYPE'),
        key: 'invoice_type',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('TEAM_ID'),
        key: 'team',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('CURRENCY'),
        key: 'currency',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('OPPORTUNITY_NO'),
        key: 'opportunity_number',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('OPPORTUNITY_ID'),
        key: 'opportunity',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('OPPORTUNITY_INSTALLMENT_ID'),
        key: 'opportunity_installment_id',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('OPPORTUNITY_SOURCE'),
        key: 'opportunity_source',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('TRANSACTION_SUBTYPE'),
        key: 'subtype',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('LEASE_EXECUTED_DATE'),
        key: 'execution_date',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('OCCUPATION_DATE'),
        key: 'occupation_date',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('DEAL_TYPE_AGILE_SPACE'),
        key: 'deal_type_agile_space',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('LEASE_FROM_DATE'),
        key: 'start_date',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('LEASE_TO_DATE'),
        key: 'end_date',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('ABSORPTION_DATE'),
        key: 'absorbtion_date',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('EARLY_TERMINATION_DATE'),
        key: 'early_termination_date',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('IS_THERE_AN_OPTION_TO_RENEW'),
        key: 'option_to_renew_the_lease',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('NOTICE_OF_CANCELLATION'),
        key: 'notice_of_cancellation_in_months',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('BANK_GUARANTEE_AMOUNT'),
        key: 'tenant_bank_guarentee_amount',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('SECURITY_DEPOSIT_AMOUNT'),
        key: 'tenant_security_deposit_amount',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('CONTRACT_TYPE'),
        key: 'contract_type',
        width: 30,
        style: { ...settings.middle }
      },
       {
        header: this.translateService.getTranslation('MIQ_AVAILABILITY_ID'),
        key: 'availability_id',
        width: 20,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('MIQ_PROPERTY_ID'),
        key: 'miq_property_id',
        width: 20,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PROPERTY_GRID_ID'),
        key: 'property_grid_id',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('BUILDING_NAME'),
        key: 'building_name',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('ADDRESS_LINE1'),
        key: 'address_line1',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('ADDRESS_LINE2'),
        key: 'address_line2',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('POSTAL_CODE'),
        key: 'postal_code',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('SUBURB'),
        key: 'suburb',
        width: 16,
        style: { ...settings.left },
      },
      {
        header: this.translateService.getTranslation('DISTRICT'),
        key: 'district',
        width: 16,
        style: { ...settings.left },
      },
      {
        header: this.translateService.getTranslation('LOCALITY'),
        key: 'locality',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('REGION'),
        key: 'region',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('COUNTRY'),
        key: 'country',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('PROPERTY_TYPE'),
        key: 'property_type',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('PROPERTY_SUBTYPE'),
        key: 'property_subtype',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('PROPERTY_TYPE_SPACE'),
        key: 'property_type_space_label',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('SPACE_CONDITION'),
        key: 'space_condition',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('PROPERTY_AREA'),
        key: 'size',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('SIZE_AREA_MEASURE'),
        key: 'size_measurement',
        width: 20,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('CALCULATION_METRIC_DESKS'),
        key: 'desks',
        width: 20,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('CALCULATION_METRIC_RACKS'),
        key: 'racks',
        width: 20,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('CALCULATION_METRIC_SERVERS'),
        key: 'servers',
        width: 20,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('CALCULATION_METRIC_MEGAWATTS'),
        key: 'megawatts',
        width: 20,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('CALCULATION_METRIC_KILOWATTS'),
        key: 'kilowatts',
        width: 20,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('CAR_PARK_SPACES'),
        key: 'car_spaces',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('FLOOR'),
        key: 'floor',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('SUITE'),
        key: 'suite',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('MANAGED_BY_CBRE'),
        key: 'managed_by_cbre',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('PRIMARY_EMPLOYEE_ID'),
        key: 'primary_employee_id',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('PRIMARY_EMPLOYEE_NAME'),
        key: 'primary_employee_name',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('PRIMARY_EMPLOYEE_FU_ID'),
        key: 'primary_employee_functional_unit_id',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('PRIMARY_EMPLOYEE_FU_DESC'),
        key: 'primary_employee_functional_unit',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('PRIMARY_EMPLOYEE_MO_ID'),
        key: 'primary_employee_managing_office_id',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('PRIMARY_EMPLOYEE_MO_DESC'),
        key: 'primary_employee_managing_office',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('REPRESENTATION_ROLE'),
        key: 'rep_role',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('CUSTOMER_ID'),
        key: 'customer_id',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('CUSTOMER_NAME'),
        key: 'represented_party',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('COMPANY_TYPE'),
        key: 'company_type',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('DEDICATED_CLIENT_NAME'),
        key: 'dedicated_client_name',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('COUNTER_PARTY_NAME'),
        key: 'counter_party_name',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('CUSTOMER_ID'),
        key: 'bill_to_customer_id',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('BILL_TO_CUSTOMER_NAME'),
        key: 'bill_to_party',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('COMPANY_TYPE'),
        key: 'bill_to_company_type',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('DEDICATED_CLIENT_NAME'),
        key: 'bill_to_dedicated_client_name',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PURCHASE_ORDER'),
        key: 'purchase_order_number',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('MONEY_IN_TRUST'),
        key: 'money_in_trust',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('COUNTER_PARTY_REPRESENTATION_ROLE'),
        key: 'counter_party_representation_role',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('COUNTER_PARTY_1'),
        key: 'counter_party_rep1',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('COUNTER_PARTY_2'),
        key: 'counter_party_rep2',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('COUNTER_PARTY_3'),
        key: 'counter_party_rep3',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('TENANT_RETAIL_CATEGORY'),
        key: 'tenant_retail_category',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('RETAIL_BRAND_NAME'),
        key: 'retail_brand_name',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('BILLING_OFFICE'),
        key: 'billing_office',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('PLACE_OF_SUPPLY'),
        key: 'place_of_supply',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('SGST_UTGST_PERCENTAGE'),
        key: 'sgst_utgst_percentage',
        width: 15,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('CGST_PERCENTAGE'),
        key: 'cgst_percentage',
        width: 15,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('IGST_PERCENTAGE'),
        key: 'igst_percentage',
        width: 15,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('CESS_PERCENTAGE'),
        key: 'cess_percentage',
        width: 15,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('GST_RATE'),
        key: 'gst_rate',
        width: 15,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('INVOICE_FEE_BASIS'),
        key: 'invoice_fee_basis',
        width: 20,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('IS_GWS_ENTITY'),
        key: 'is_gws_entity',
        width: 20,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('GWS_ENTITY_LOCATION'),
        key: 'gws_entity_location',
        width: 20,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('PAYMENT_TERMS'),
        key: 'payment_terms',
        width: 20,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('PAYMENT_DUE_DATE'),
        key: 'payment_due_date',
        width: 20,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('INVOICE_HEADER'),
        key: 'invoice_header',
        width: 20,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('TRANSACTION_AMOUNT'),
        key: 'transaction_amount',
        width: 20,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('TOTAL_CBRE_FEE'),
        key: 'total_invoice_amount',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('IS_DATA_CENTER_DEAL'),
        key: 'is_data_center_deal',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('CREATED_BY'),
        key: 'created_by',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('SUBMITTED_BY'),
        key: 'submitted_by',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('APPROVED_BY'),
        key: 'approved_by',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('CONFIDENTIALITY_STATUS'),
        key: 'confidentiality_status',
        width: 30,
        style: { ...settings.middle },
      },

    ];
  }

  getDataSourceSettings(): ColDef[] {
    return [
      {
        ...fieldIdCol,
        field: 'finishline_id',
        headerName: this.translateService.getTranslation('FINISHLINE_ID'),
      },
      {
        ...fieldInvoiceIdCol,
        field: 'invoice_id',
        headerName: this.translateService.getTranslation('INVOICE_ID'),
        cellRenderer: null,
      },
      {
        ...fieldTransactionTypeCol,
        headerName: this.translateService.getTranslation('TRANSACTION_TYPE'),
      },
      {
        ...fieldDateCol,
        field: 'invoiced_time',
        headerName: this.translateService.getTranslation('INVOICE_DT'),
      },
      {
        ...fieldInvoiceTypeCol,
        headerName: this.translateService.getTranslation('INVOICE_TYPE'),
      },    
      {
        ...fieldTeamCol,
        headerName: this.translateService.getTranslation('TEAM_ID'),
      },
      {
        ...fieldCurrencyCol,
        headerName: this.translateService.getTranslation('CURRENCY'),
      },     
      {
        ...fieldOppNumberCol,
        headerName: this.translateService.getTranslation('OPPORTUNITY_NO'),
      },   
      {
        ...fieldOpportunityCol,
        headerName: this.translateService.getTranslation('OPPORTUNITY_ID'),
      },
      {
        ...fieldOpportunityInstallmentCol,
        headerName: this.translateService.getTranslation('OPPORTUNITY_INSTALLMENT_ID'),
      },
      {
        ...fieldOpportunitySourceCol,
        headerName: this.translateService.getTranslation('OPPORTUNITY_SOURCE'),
      },
      {
        ...fieldTransSubtypeCol,
        field: 'subtype',
        headerName: this.translateService.getTranslation('TRANSACTION_SUBTYPE'),
      },
      {
        ...fieldExecutionDateCol,
        width: 200,
        headerName: this.translateService.getTranslation('EXECUTION_DATE'),
      },            
      {
        ...fieldDateCol,
        field: 'occupation_date',
        width: 200,
        headerName: this.translateService.getTranslation('OCCUPATION_DATE'),
      },
      {
        ...fieldDealTypeAgileSpaceCol,
        headerName: this.translateService.getTranslation('DEAL_TYPE_AGILE_SPACE'),
      },
      {
        ...fieldDateCol,
        field: 'start_date',
        width: 200,
        headerName: this.translateService.getTranslation('LEASE_FROM_DATE'),
      },
      {
        ...fieldDateCol,
        field: 'end_date',
        width: 200,
        headerName: this.translateService.getTranslation('LEASE_TO_DATE'),
      },
      {
        ...fieldDateCol,
        field: 'absorbtion_date',
        width: 200,
        headerName: this.translateService.getTranslation('ABSORPTION_DATE'),
      },
      {
        ...fieldDateCol,
        field: 'early_termination_date',
        width: 200,
        headerName: this.translateService.getTranslation('EARLY_TERMINATION_DATE'),
      },
      {
        ...fieldOptionToRenewTheLeaseCol,
        headerName: this.translateService.getTranslation('IS_THERE_AN_OPTION_TO_RENEW'),
      },
      {
        ...fieldNoticeOfCancellationInMonthsCol,
        headerName: this.translateService.getTranslation('NOTICE_OF_CANCELLATION'),
      },
      {
        ...fieldTenantBankGuaranteeAmountCol,
        headerName: this.translateService.getTranslation('BANK_GUARANTEE_AMOUNT'),
      },
      {
        ...fieldTenantSecurityDepositAmountCol,
        headerName: this.translateService.getTranslation('SECURITY_DEPOSIT_AMOUNT'),
      },
      {
        ...fieldContractTypeCol,
        headerName: this.translateService.getTranslation('CONTRACT_TYPE'),
      },
      {
        ...fieldMiqAvailabilityIdCol,
        headerName: this.translateService.getTranslation('MIQ_AVAILABILITY_ID'),
      },
      {
        ...fieldMiqIdCol,
        headerName: this.translateService.getTranslation('MIQ_PROPERTY_ID'),
      },
      {
        ...fieldGridIdCol,
        field: 'property_grid_id',
        headerName: this.translateService.getTranslation('PROPERTY_GRID_ID'),
      },
      {
        ...fieldBuildingNameCol,
        headerName: this.translateService.getTranslation('BUILDING_NAME'),
      },
      {
        ...fieldAddressLine1Col,
        headerName: this.translateService.getTranslation('ADDRESS_LINE1'),
      },
      {
        ...fieldAddressLine2Col,
        headerName: this.translateService.getTranslation('ADDRESS_LINE2'),
      },
      {
        ...fieldPostcodeCol,
        headerName: this.translateService.getTranslation('POSTAL_CODE'),
      },      
      {
        ...fieldSuburbCol,
        headerName: this.translateService.getTranslation('SUBURB'),
      },
      {
        ...fieldDistrictCol,
        headerName: this.translateService.getTranslation('DISTRICT'),
      },
      {
        ...fieldLocalityCol,
        headerName: this.translateService.getTranslation('LOCALITY'),
      },
      {
        ...fieldRegionCol,
        headerName: this.translateService.getTranslation('REGION'),
      },      
      {
        ...fieldCountryCol,
        headerName: this.translateService.getTranslation('COUNTRY'),
      },      
      {
        ...fieldPropertyTypeCol,
        headerName: this.translateService.getTranslation('PROPERTY_TYPE'),
      },      
      {
        ...fieldPropertySubtypeCol,
        headerName: this.translateService.getTranslation('PROPERTY_SUBTYPE'),
      },      
      {
        ...fieldPropertyTypeSpaceLabelCol,
        headerName: this.translateService.getTranslation('PROPERTY_TYPE_SPACE'),
      },
      {
        ...fieldSpaceConditionCol,
        headerName: this.translateService.getTranslation('SPACE_CONDITION'),
      },
      {
        ...fieldPropertyAreaCol,
        field: 'size',
        headerName: this.translateService.getTranslation('PROPERTY_AREA'),
      },
      {
        ...fieldSizeAreaMeasureCol,
        field: 'size_measurement',
        headerName: this.translateService.getTranslation('SIZE_AREA_MEASURE'),
      },
      {
        ...fieldPropertyAreaCol,
        field: 'desks',
        headerName: this.translateService.getTranslation('CALCULATION_METRIC_DESKS'),
      },
      {
        ...fieldPropertyAreaCol,
        field: 'racks',
        headerName: this.translateService.getTranslation('CALCULATION_METRIC_RACKS'),
      },
      {
        ...fieldPropertyAreaCol,
        field: 'servers',
        headerName: this.translateService.getTranslation('CALCULATION_METRIC_SERVERS'),
      },
      {
        ...fieldPropertyAreaCol,
        field: 'megawatts',
        headerName: this.translateService.getTranslation('CALCULATION_METRIC_MEGAWATTS'),
      },
      {
        ...fieldPropertyAreaCol,
        field: 'kilowatts',
        headerName: this.translateService.getTranslation('CALCULATION_METRIC_KILOWATTS'),
      },
      {
        ...fieldCarParkSpacesCol,
        field: 'car_spaces',
        headerName: this.translateService.getTranslation('CAR_PARK_SPACES'),
      },
      {
        ...fieldFloorCol,
        headerName: this.translateService.getTranslation('FLOOR'),
      },
      {
        ...fieldSuiteCol,
        headerName: this.translateService.getTranslation('SUITE'),
      },
      {
        ...fieldPropertyManagedCol,
        headerName: this.translateService.getTranslation('MANAGED_BY_CBRE'),
      },
      {
        ...fieldPrimaryEmployeeIdCol,
        headerName: this.translateService.getTranslation('PRIMARY_EMPLOYEE_ID'),
      },
      {
        ...fieldPrimaryEmployeeNameCol,
        headerName: this.translateService.getTranslation('PRIMARY_EMPLOYEE_NAME'),
      },
      {
        ...fieldPrimaryEmployeeFunctionalUnitIdCol,
        headerName: this.translateService.getTranslation('PRIMARY_EMPLOYEE_FU_ID'),
      },
      {
        ...fieldPrimaryEmployeeFunctionalUnitCol,
        headerName: this.translateService.getTranslation('PRIMARY_EMPLOYEE_FU_DESC'),
      },
      {
        ...fieldPrimaryEmployeeManagingOfficeIdCol,
        headerName: this.translateService.getTranslation('PRIMARY_EMPLOYEE_MO_ID'),
      },
      {
        ...fieldPrimaryEmployeeManagingOfficeCol,
        headerName: this.translateService.getTranslation('PRIMARY_EMPLOYEE_MO_DESC'),
      },      
      {
        ...fieldRepRolCol,
        field: 'rep_role',
        headerName: this.translateService.getTranslation('REP_ROLE'),
      },      
      {
        ...fieldCustomerIdCol,
        headerName: this.translateService.getTranslation('CUSTOMER_ID'),
      },      
      {
        ...fieldRepresentedPartyCol,
        headerName: this.translateService.getTranslation('CUSTOMER_NAME'),
      },
      {
        ...fieldCompanyTypeCol,
        headerName: this.translateService.getTranslation('COMPANY_TYPE'),
      },     
      {
        ...fieldDedicatedClientNameCol,
        headerName: this.translateService.getTranslation('DEDICATED_CLIENT_NAME'),
      },       
      {
        ...fieldCounterPartyCol,
        headerName: this.translateService.getTranslation('COUNTER_PARTY_NAME'),
      },    
      {
        ...fieldCustomerIdCol,
        field: 'bill_to_customer_id',
        headerName: this.translateService.getTranslation('CUSTOMER_ID'),
      },   
      {
        ...fieldCustomerNameCol,
        field: 'bill_to_party',
        headerName: this.translateService.getTranslation('BILL_TO_CUSTOMER_NAME'),
      },     
      {
        ...fieldCompanyTypeCol,
        field: 'bill_to_company_type',
        headerName: this.translateService.getTranslation('COMPANY_TYPE'),
      },      
      {
        ...fieldDedicatedClientNameCol,
        field: 'bill_to_dedicated_client_name',
        headerName: this.translateService.getTranslation('DEDICATED_CLIENT_NAME'),
      },      
      {
        ...fieldPurchaseOrderCol,
        field: 'purchase_order_number',
        headerName: this.translateService.getTranslation('PURCHASE_ORDER'),
      },      
      {
        ...fieldMoneyInTrustCol,
        headerName: this.translateService.getTranslation('MONEY_IN_TRUST'),
      },      
      {
        ...fieldRepRolCol,
        field: 'counter_party_representation_role',
        headerName: this.translateService.getTranslation('COUNTER_PARTY_REPRESENTATION_ROLE'),
      },
      {
        ...fieldCounterPartyCol,
        field: 'counter_party_rep1',
        minWidth: 250,
        headerName: this.translateService.getTranslation('COUNTER_PARTY_1'),
      },  
      {
        ...fieldCounterPartyCol,
        field: 'counter_party_rep2',
        minWidth: 250,
        headerName: this.translateService.getTranslation('COUNTER_PARTY_2'),
      },  
      {
        ...fieldCounterPartyCol,
        field: 'counter_party_rep3',
        minWidth: 250,
        headerName: this.translateService.getTranslation('COUNTER_PARTY_3'),
      },      
      {
        ...fieldTenantRetailCategoryCol,
        headerName: this.translateService.getTranslation('TENANT_RETAIL_CATEGORY'),
      },
      {
        ...fieldRetailBrandNameCol,
        headerName: this.translateService.getTranslation('RETAIL_BRAND_NAME'),
      },
      {
        ...fieldBillingOfficeCol,
        headerName: this.translateService.getTranslation('BILLING_OFFICE'),
      },
      {
        ...fieldPlaceOfSupplyCol,
        headerName: this.translateService.getTranslation('PLACE_OF_SUPPLY'),
      },      
      {
        ...fieldSgstUtgstPercentageCol,
        headerName: this.translateService.getTranslation('SGST_UTGST_PERCENTAGE'),
      },      
      {
        ...fieldSgstUtgstPercentageCol,
        field: 'cgst_percentage',
        headerName: this.translateService.getTranslation('CGST_PERCENTAGE'),
      },      
      {
        ...fieldSgstUtgstPercentageCol,
        field: 'igst_percentage',
        headerName: this.translateService.getTranslation('IGST_PERCENTAGE'),
      },
      {
        ...fieldSgstUtgstPercentageCol,
        field: 'cess_percentage',
        headerName: this.translateService.getTranslation('CESS_PERCENTAGE'),
      },      
      {
        ...fieldGstRateCol,
        headerName: this.translateService.getTranslation('GST_RATE'),
      },    
      {
        ...fieldInvoiceFeeBasisCol,
        headerName: this.translateService.getTranslation('INVOICE_FEE_BASIS'),
      },   
      {
        ...fieldIsGwsEntityCol,
        headerName: this.translateService.getTranslation('IS_GWS_ENTITY'),
      },     
      {
        ...fieldGwsEntityLocationCol,
        headerName: this.translateService.getTranslation('GWS_ENTITY_LOCATION'),
      },      
      {
        ...fieldPaymentTermsCol,
        headerName: this.translateService.getTranslation('PAYMENT_TERMS'),
      },         
      {
        ...fieldDateCol,
        field: 'payment_due_date',
        headerName: this.translateService.getTranslation('PAYMENT_DUE_DATE'),
      },         
      {
        ...fieldInvoiceHeaderCol,
        headerName: this.translateService.getTranslation('INVOICE_HEADER'),
      },     
      {
        ...fieldTotalInvoiceAmountCol,
        field: 'transaction_amount',
        headerName: this.translateService.getTranslation('TRANSACTION_AMOUNT'),
      }, 
      {
        ...fieldTotalInvoiceAmountCol,
        headerName: this.translateService.getTranslation('TOTAL_CBRE_FEE'),
      },
      {
        ...fieldIsDataCenterDealCol,
        headerName: this.translateService.getTranslation('IS_DATA_CENTER_DEAL'),
      },    
      {
        ...fieldCreatedByCol,
        headerName: this.translateService.getTranslation('CREATED_BY'),
      },            
      {
        ...fieldSubmittedByCol,
        headerName: this.translateService.getTranslation('SUBMITTED_BY'),
      },
      {
        ...fieldApprovedByCol,
        headerName: this.translateService.getTranslation('APPROVED_BY'),
      },
      {
        ...fieldConfidentialityStatusCol,
        headerName: this.translateService.getTranslation('CONFIDENTIALITY_STATUS'),
      },           
    ];
  }
}
